import React from 'react';
import dateformat from 'dateformat';

import * as S from './HeaderReschedule.styles';

import IconSelector from '@ibibo/icon-selector';

const HeaderReschedule = ({activeTab, hotelInfo, hasRefund}) => {
  if (!hotelInfo) {
    return null;
  }
  const {hotelName, checkin, checkout} = hotelInfo;
    return(
      <S.HeaderCanelMainWrap>
        <S.HeaderCancelOuterWrap>
          <S.HeaderCancelImgWrap>
            <IconSelector iconKey='modifyheader'/>
          </S.HeaderCancelImgWrap>
          <S.HeaderCancelInfoWrap>
            <S.HeaderCancelText>Modify Booking</S.HeaderCancelText>
            <S.HeaderCancelInfoInnerWrap>
              <S.HeaderCancelHtlInfo>{hotelName}</S.HeaderCancelHtlInfo>
              <S.HeaderCancelHtlDateInfoWrap>
                <S.HeaderCacnelHtlDateImg>
                  <IconSelector iconKey='calendergrey'/>
                </S.HeaderCacnelHtlDateImg>
                <S.HeaderCancelDateText>{dateformat(checkin, 'dd mmm')} - {dateformat(checkout, 'dd mmm')}</S.HeaderCancelDateText>
              </S.HeaderCancelHtlDateInfoWrap>
            </S.HeaderCancelInfoInnerWrap>
          </S.HeaderCancelInfoWrap>
        </S.HeaderCancelOuterWrap>

        <S.HeaderStepBlock>
          <S.HeaderStepInnerBlock>
            <S.HeaderSetpNormalBlock isActive={activeTab === 'details'}>
              <S.HeaderStepWrap isActive={activeTab === 'details'}>1</S.HeaderStepWrap>
              <S.HeaderStepText isActive={activeTab === 'details'}>Change Booking Details</S.HeaderStepText>
            </S.HeaderSetpNormalBlock>
            <IconSelector iconKey={activeTab === 'details' ? 'arrowactive' : 'arrow'} props={{margin:'0 0 0 -1px'}}/>
          </S.HeaderStepInnerBlock>

          <S.HeaderStepInnerBlock>
            <S.HeaderSetpNormalBlock isActive={activeTab === 'cost'}>
              <S.HeaderStepWrap isActive={activeTab === 'cost'}>2</S.HeaderStepWrap>
              <S.HeaderStepText isActive={activeTab === 'cost'}>View Additonal Cost</S.HeaderStepText>
            </S.HeaderSetpNormalBlock>
            <IconSelector iconKey={activeTab === 'cost' ? 'arrowactive' : 'arrow'} props={{margin:'0 0 0 -1px'}}/>
          </S.HeaderStepInnerBlock>

          <S.HeaderStepInnerBlock>
            <S.HeaderSetpNormalBlock isActive={activeTab === 'pay' || activeTab === 'refund'}>
              <S.HeaderStepWrap isActive={activeTab === 'confirm'}>3</S.HeaderStepWrap>
              <S.HeaderStepText isActive={activeTab === 'confirm'}>{hasRefund ? 'Confirm' : 'Pay and Confirm'}</S.HeaderStepText>
            </S.HeaderSetpNormalBlock>
            {/* <IconSelector iconKey={activeTab === 'confirm' ? 'arrowactive' : 'arrow'} props={{margin:'0 0 0 -1px'}}/> */}
          </S.HeaderStepInnerBlock>
        </S.HeaderStepBlock>
      </S.HeaderCanelMainWrap>
    );
}

export default HeaderReschedule;